import * as React from "react"

import { cn } from "@/lib/utils"

const TextArea = React.forwardRef<HTMLInputElement, React.ComponentProps<"textarea">>(
  ({ className,  ...props }, ref) => {
    return (
      <textarea
       
        className={cn(
          "flex h-8 w-full rounded-md border border-input dark:border-zinc-400 bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
TextArea.displayName = "TextArea"

export { TextArea }
